var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.deviceClass == 'pc' ? 'shortBox' : 'shortBoxH'},[_c('pageModel3')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }